var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/object-is-prototype-of.js
// module id = 41
// module chunks = 0